import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import Steps from "../../../../components/common/steps/Steps";
import { required } from "../../../../utils/forms/validators";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import {
  getProject,
  PROJECT_BASICS_FORM
} from "../../../../actions/project.actions";

import CategoryRadio from "./CategoryRadio";
import DurationRadio from "./DurationRadio";
import styles from "./ProjectBasics.scss";

class ProjectBasics extends Component {
  render() {
    const { submitting, valid } = this.props;

    return (
      <section className={styles.projectBasics}>
        <div className={styles.header}>
          <Steps steps={this.props.steps} activeStep={0} track={true} />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>Project Basics</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.subheading}>1. Select a Category</div>
                <div className={styles.subtitle}>
                  Pick the category of the role you’re hiring.
                  <br />
                  Don’t see the category that fits your need?
                  <a
                    href="https://thesecondshift.com/contact-us"
                    target="_blank"
                    onClick={() =>
                      Mixpanel.track("Project Creation - Basics - Contact Us")
                    }
                  >
                    {" "}
                    Contact us.
                  </a>
                </div>
              </FormGroup>
              <FormGroup>
                <FormGroup>
                  <Field
                    name="category_id"
                    options={this.props.categories}
                    groupName="category_id"
                    component={CategoryRadio}
                    validate={required}
                  />
                </FormGroup>
              </FormGroup>

              <div className={styles.divider} />

              {/* <FormGroup>
                <div className={styles.subheading}>
                  2. How long do you expect the project to take?
                </div>

                <FormGroup>
                  <Field
                    name="duration_id"
                    options={this.props.projectDurations}
                    component={DurationRadio}
                    groupName="duration_id"
                    validate={required}
                  />
                </FormGroup>
              </FormGroup> */}

              <FormGroup>
                <div className={styles.subheading}>
                  2. What type of job is this?
                </div>

                <FormGroup>
                  <Field
                    name="job_type_id"
                    options={this.props.jobTypes}
                    component={DurationRadio}
                    groupName="job_type_id"
                    validate={required}
                  />
                </FormGroup>
              </FormGroup>

              <div className={styles.divider} />

              <FormGroup>
                <div className={styles.subheading}>3. What's your budget?</div>
                <div className={styles.subheadingHint}>
                  Not sure of your budget? Don’t worry! This information is for
                  internal reference only and will not be shown to the members.
                </div>

                <FormGroup>
                  <Field
                    name="company_budget_id"
                    options={this.props.companyBudgets}
                    component={DurationRadio}
                    groupName="company_budget_id"
                    validate={required}
                  />
                </FormGroup>
              </FormGroup>

              <div className={styles.dividerDouble} />

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Continue"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

ProjectBasics = reduxForm({
  form: PROJECT_BASICS_FORM,
  enableReinitialize: true,
  destroyOnUnmount: true
})(ProjectBasics);

ProjectBasics = connect(
  state => {
    return {
      initialValues: state.project.data.data
    };
  },
  dispatch => {
    return {
      getProject: () => dispatch(getProject())
    };
  }
)(ProjectBasics);

export default ProjectBasics;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/ProjectBasics.js